import * as React from "react";
import form from "@/utils/form";
import contract from "@/utils/contract";
import { useTheme } from "@/hooks/useTheme";
import { useFormHandler } from "@/utils/hooks";
import Title from "@/components/atoms/Title";
import FormBlock from "@/components/molecules/FormBlock";
import ContractContext, { initContractStore } from "@/contexts/Contract";
import FormContext, { initFormStore, updateFormValues } from "@/contexts/Form";
import PropertyType, {
  propertyTypeOptionsFromAreaInfo,
  queryParamsPropertyTypeMapping,
} from "@/constants/PropertyType";
import { useQueryParams } from "@/utils/hooks";
import QueryKey from "@/constants/QueryKey";

type TypeBlockProps = {
  onNext: () => void;
};

const TypeBlock = ({ onNext }: TypeBlockProps) => {
  const { COLOR_THEME } = useTheme();
  const query = useQueryParams();
  let queryParamPropertyType = query.get(QueryKey.PROPERTY_TYPE);
  queryParamPropertyType = queryParamsPropertyTypeMapping(queryParamPropertyType);
  const [propertyType, setPropertyType] = React.useState([]);

  const {
    state: { propertyTypes },
  } = React.useContext(ContractContext) || initContractStore(contract);
  const {
    state: { values },
    dispatch,
  } = React.useContext(FormContext) || initFormStore(form);
  const [isSelected, setIsSelected] = React.useState(false);

  const isSkipPropertyTypes = propertyTypes && propertyTypes.length === 1;

  const handlePropertyType = useFormHandler("propertyType");

  React.useEffect(() => {
    if (!propertyTypes) {
      setPropertyType(propertyTypes);
    }
  }, [propertyTypes]);

  React.useEffect(() => {
    if (
      queryParamPropertyType === PropertyType.HOUSE ||
      queryParamPropertyType === PropertyType.LAND ||
      queryParamPropertyType === PropertyType.MANSION
    ) {
      setIsSelected(true);
      handlePropertyType(queryParamPropertyType);
    }
  }, [queryParamPropertyType]);

  React.useEffect(() => {
    if (isSkipPropertyTypes || (values.propertyType && isSelected)) {
      onNext();
    }
  }, [propertyTypes, isSelected]);

  const handleOptionSelect = (type: string) => {
    setIsSelected(true);
    handlePropertyType(type);
    if (type !== PropertyType.MANSION) {
      dispatch(
        updateFormValues({
          values: {
            line: "",
            station: "",
          },
          validates: {
            line: "",
            station: "",
          },
        })
      );
    }
    if (queryParamPropertyType === type) {
      dispatch(
        updateFormValues({
          values: {
            propertyCity: localStorage.getItem("propertyCity") as string,
            propertyTown: localStorage.getItem("propertyTown") as string,
          },
          validates: {},
        })
      );
    }
  };

  const getSelectedValue = (): string => {
    const optionValues = propertyTypeOptionsFromAreaInfo(propertyTypes);
    if (optionValues?.length === 1) {
      return optionValues[0].value;
    } else {
      if (isSelected) {
        return values.propertyType as string;
      } else {
        return "not_selected";
      }
    }
  };

  return (
    <React.Fragment>
      {!isSkipPropertyTypes && (
        <Title color={COLOR_THEME.extras?.secondary}>査定する物件のタイプを選択してください</Title>
      )}
      <FormBlock.TypeSelect
        options={propertyTypeOptionsFromAreaInfo(propertyTypes) as Option[]}
        backgroundColor={COLOR_THEME.extras?.primary}
        selected={getSelectedValue()}
        handleOptionSelect={handleOptionSelect}
      />
    </React.Fragment>
  );
};

export default TypeBlock;
